import {Alpine} from '../../vendor/livewire/livewire/dist/livewire.esm';

import Tooltip from '@ryangjchandler/alpine-tooltip';
import Clipboard from '@ryangjchandler/alpine-clipboard';

Alpine.plugin(Tooltip);
Alpine.plugin(Clipboard);
